module.exports = __webpack_public_path__ + "static/img/1.6735536.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/sp/1.png
// module id = F+n3
// module chunks = 0